import { Flag, useFeatureFlags } from '@previo/feature-flags'
import type { NavigationGuardNext, RouteLocationNormalized } from 'vue-router'
import { Routes } from '~/router/routes'

const checkTaxSettingsFlag = async (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext,
): Promise<void> => {
  const ff = useFeatureFlags()
  await ff.waitForInit()

  if (ff.isEnabled(Flag.PMS_TAX_SETTINGS_ENABLED).value) {
    return next()
  }

  return next({ name: Routes.VISITOR_TAX_INDEX_P1, query: to.query })
}

export default checkTaxSettingsFlag
